import { Link, useLocation, useNavigate } from "react-router-dom";
import { Bell, Menu, ChevronRight, LogOut } from "lucide-react";
import useAuthStore from "../../stores/useAuthStore";
import useDossierStore from "../../stores/useDossierStore";

const Header = ({ onMenuToggle, sidebarOpen: _sidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const { currentDossier } = useDossierStore();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  const getBreadcrumbs = () => {
    const path = location.pathname;
    const segments = path.split("/").filter(Boolean);

    if (segments.length === 0) {
      return [{ label: "Accueil", path: "/" }];
    }

    const breadcrumbs = [{ label: "Accueil", path: "/" }];
    let currentPath = "";

    segments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      let label;

      if (UUID_RE.test(segment) && segments[index - 1] === "dossiers" && currentDossier?.reference) {
        label = currentDossier.reference;
      } else {
        label = segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ");
      }

      breadcrumbs.push({ label, path: currentPath });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();
  const initials = user
    ? `${user.prenom?.[0] || ""}${user.nom?.[0] || ""}`.toUpperCase()
    : "?";

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center px-6">
      <div className="flex-1 flex items-center gap-4">
        <button
          onClick={onMenuToggle}
          className="p-2 hover:bg-slate-100 rounded-lg transition-colors lg:hidden"
        >
          <Menu size={20} className="text-slate-700" />
        </button>

        <nav className="flex items-center gap-2">
          {breadcrumbs.map((crumb, index) => (
            <div key={crumb.path} className="flex items-center gap-2">
              <a
                href={crumb.path}
                className="text-sm text-slate-600 hover:text-slate-900 transition-colors"
              >
                {crumb.label}
              </a>
              {index < breadcrumbs.length - 1 && (
                <ChevronRight size={16} className="text-slate-400" />
              )}
            </div>
          ))}
        </nav>
      </div>

      <div className="flex items-center gap-4">
        <button className="p-2 hover:bg-slate-100 rounded-lg transition-colors relative">
          <Bell size={20} className="text-slate-700" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
        </button>

        <Link to="/profil" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          {user && (
            <span className="text-sm text-slate-600 hidden sm:block">
              {user.prenom} {user.nom}
            </span>
          )}
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-carex-500 to-carex-600 flex items-center justify-center text-white font-semibold text-sm">
            {initials}
          </div>
        </Link>

        <button
          onClick={handleLogout}
          title="Se déconnecter"
          className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
        >
          <LogOut size={20} className="text-slate-700" />
        </button>
      </div>
    </header>
  );
};

export default Header;
